import { createPaginationAtoms } from './utils/filtersFactory';

export const { rowsPerPageFilterAtom, pageFilterAtom } = createPaginationAtoms();
